import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForOf } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { UiAvatarComponent, UiSearchComponent, TruncateDirective } from '@ui';
import { LetDirective } from '@ngrx/component';
import { OrganizationModels } from '@share-models';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-switch-organization',
  templateUrl: './switch-organization.component.html',
  styleUrl: './switch-organization.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgForOf,
    ReactiveFormsModule,
    TranslatePipe,
    UiAvatarComponent,
    UiSearchComponent,
    TruncateDirective,
    LetDirective,
  ],
})
export class SwitchOrganizationComponent implements OnInit {
  @Input() public activeOrganization: OrganizationModels.OrganizationDocument | null = null;
  @Input() public userOrganizations: OrganizationModels.UserOrganizationDropDown[] = [];
  @Output() public readonly onMenuClosed = new EventEmitter<void>();

  public filteredOrganizations$!: Observable<OrganizationModels.UserOrganizationDropDown[]>;

  public readonly searchControl = new FormControl<string>('');

  constructor(private readonly authService: AuthService) {}

  public ngOnInit(): void {
    this.filteredOrganizations$ = combineLatest([
      this.searchControl.valueChanges.pipe(startWith('')),
    ]).pipe(
      map(([query]) => {
        const activeId = this.activeOrganization?._id?.toString();
        const orgs = this.userOrganizations.filter((o) => o.id !== activeId);
        if (!query) {
          return orgs;
        }
        const q = query.toLowerCase();
        return orgs.filter((o) => o.name.toLowerCase().includes(q));
      }),
    );
  }

  public async switchOrg(id: string): Promise<void> {
    this.onMenuClosed.emit();
    await this.authService.switchTenant(id);
  }
}
